import { useLocale } from "@outschool/localization";
import { useDeviceTypeContext } from "@outschool/ui-utils";
import React from "react";
import { useParams } from "react-router-dom";

import ContentfulPageLayout from "../../components/contentful/ContentfulPageLayout";
import AccordionPageContent from "./AccordionPageContent";
import BasicPageContent from "./BasicContentfulPage";
import ContentfulPageHeader from "./ContentfulPageHeader";
import useContentfulAccordionPage from "./useContentfulAccordionPage";
import useFetchContentfulBasicPage from "./useContentfulBasicPage";

export default function TermsPages() {
  const { slug } = useParams<{ slug: string }>();

  const { deviceType } = useDeviceTypeContext();
  const locale = useLocale();

  const accordionPage = useContentfulAccordionPage({
    slug,
    locale
  });
  const basicPage = useFetchContentfulBasicPage({
    slug,
    locale
  });
  const page = accordionPage ?? basicPage;

  if (!page) {
    return null;
  }

  return (
    <ContentfulPageLayout
      title={page.title ?? ""}
      deviceType={deviceType}
      trackingName={page.__typename ?? ""}
    >
      {/* Page title & preview banner */}
      <ContentfulPageHeader page={page} />
      {accordionPage ? (
        <AccordionPageContent page={page} deviceType={deviceType} />
      ) : (
        <BasicPageContent page={page} />
      )}
    </ContentfulPageLayout>
  );
}
